export default __webpack_public_path__ + "static/media/portfolio-186.47b4ab49.jpg";